import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { User } from "../../features/users/models/user.model";
import { useUserStore } from "../../features/users/store";
import { API_REST_METHODS, ENVIRONMENTS } from "../constants";
import { getEnvironment } from "../utils";
import fetcher from "./fetcher";

const postRequest = (url: string, { arg }: { arg: any }) =>
    fetcher(url, {
        options: {
            method: API_REST_METHODS.POST,
            body: JSON.stringify(arg),
        },
    });

export const useCurrentUser = () => {
    const { user, setUser } = useUserStore();

    const { trigger: triggerSetProfile } = useSWRMutation(
        "/api/analytics/setProfile",
        postRequest
    );

    const { data, error, isLoading, mutate } = useSWR(
        "/api/permission-management/v1/users/me",
        (url) => fetcher(url)
    );

    // Set profile data when it is fetched for the first time to keep it up to date in mixpanel
    if (data && data.id !== user?.id) {
        setUser(data);

        if (getEnvironment() === ENVIRONMENTS.PRODUCTION) {
            triggerSetProfile({
                profileData: data,
            });
        } else {
            console.log(
                "Track event skipped in development and staging: triggerSetProfile"
            );
        }
    }

    return {
        user: data as User | undefined,
        isLoading,
        isError: error,
        mutateCurrentUser: mutate,
    };
};
